import { z } from '../utils/zod-extend'

export const idSchema = z.string()
                         .min(3)
                         .openapi({ example: 'bbc66358-6efa-4ff0-8f08-bd8da93555fa' })

export const idParamsSchema = z.object({
  id: idSchema.openapi({
    param: {
      name: 'id',
      in: 'path',
    },
  }),
})

export type IdParams = z.infer<typeof idParamsSchema>

export const isoStringDatetimeSchema = z.preprocess(
  (arg) => {
    if (arg instanceof Date) {
      return arg.toISOString()
    }

    return arg
  },
  z.string().datetime(),
).openapi('IsoStringDatetime', { example: '2024-11-19T06:47:43.327Z' })
